import { render } from "./SomethingElse.vue?vue&type=template&id=51a53ae0&scoped=true"
import script from "./SomethingElse.vue?vue&type=script&lang=js"
export * from "./SomethingElse.vue?vue&type=script&lang=js"

import "./SomethingElse.vue?vue&type=style&index=0&id=51a53ae0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a53ae0"]])

export default __exports__